'use client';

import React from 'react';
import { useUI } from '@/app/context/UIContext';
import { useAuth } from '@/hooks/useAuth';
import { useTenant } from '@/app/context/TenantContext';
import { useRouter, usePathname } from 'next/navigation';

export default function Header() {
  const { onOpenDati, onOpenImpostazioni, onGoHome } = useUI();
  const { user } = useAuth();
  const { brand, loading: tenantLoading } = useTenant();
  const router = useRouter();
  const pathname = usePathname();

  const today = new Date();
  const dateStr = today.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });

  const handleSignOut = async () => {
    try {
      const { getSupabaseClient } = await import('@/lib/supabase/auth');
      await getSupabaseClient().auth.signOut();
      router.push('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const isRazionale = pathname === '/landing/razionale';
  const nomeBreve = brand?.nome_breve ?? '3940';
  const colorePrimario = brand?.colore_primario ?? '#f97316';

  if (tenantLoading) return null;

  return (
    <header className="topbar">
      {/* Sinistra */}
      {isRazionale ? (
        <button className="iconbtn" aria-label="Indietro" title="Indietro" onClick={() => router.back()}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
      ) : (
        <button
          onClick={() => onGoHome?.()}
          className="text-sm font-bold hover:opacity-70 transition px-2 py-1"
          style={{ color: colorePrimario }}
        >
          Home
        </button>
      )}

      {/* Centro: Nome tenant e Data */}
      <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 pointer-events-none">
        {brand?.logo_url
          ? (
            <>
              <img src={brand.logo_url} alt={nomeBreve} className="h-7 w-auto object-contain" />
              <span className="font-bold text-sm whitespace-nowrap tracking-tight" style={{ color: colorePrimario }}>
                {nomeBreve}
              </span>
            </>
          )
          : <span className="font-bold text-xl whitespace-nowrap tracking-tight" style={{ color: colorePrimario }}>{nomeBreve}</span>
        }
        <span className="text-slate-400 text-xs whitespace-nowrap">
          {dateStr}
        </span>
      </div>

      {/* Destra */}
      {!isRazionale && (
        <div className="flex items-center gap-2 ml-auto">
          {onOpenDati && (
            <button className="iconbtn" aria-label="Studio" onClick={onOpenDati} title="Studio">
              📖
            </button>
          )}
          {onOpenImpostazioni && (
            <button className="iconbtn" aria-label="Impostazioni" onClick={onOpenImpostazioni} title="Impostazioni">
              ⚙️
            </button>
          )}
          {user && (
            <button
              onClick={handleSignOut}
              className="text-sm font-bold hover:opacity-70 transition px-2 py-1"
              style={{ color: colorePrimario }}
            >
              Esci
            </button>
          )}
        </div>
      )}
    </header>
  );
}